import { render, staticRenderFns } from "./DashboardJobsChart.vue?vue&type=template&id=5240f652&scoped=true"
import script from "./DashboardJobsChart.vue?vue&type=script&lang=js"
export * from "./DashboardJobsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240f652",
  null
  
)

export default component.exports